// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"93070adb","202":"a94b0ecc","763":"27a5cad3"}[chunkId] + ".chunk.js";
};